var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReportForInsights(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#EAFAFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7188 17.9167H16.433V19.3333H12.7188V17.9167ZM12.7188 14.375H18.2902V15.7917H12.7188V14.375ZM12.7188 21.4583H15.0402V22.875H12.7188V21.4583Z",
    fill: "#348287"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8182 9.82143H19.0455V9.21429C19.0455 8.89224 18.9209 8.58338 18.6993 8.35566C18.4777 8.12793 18.1771 8 17.8636 8H13.1364C12.8229 8 12.5223 8.12793 12.3007 8.35566C12.0791 8.58338 11.9545 8.89224 11.9545 9.21429V9.82143H10.1818C9.86838 9.82143 9.56778 9.94936 9.34615 10.1771C9.12451 10.4048 9 10.7137 9 11.0357V23.7857C9 24.1078 9.12451 24.4166 9.34615 24.6443C9.56778 24.8721 9.86838 25 10.1818 25H20.8182C21.1316 25 21.4322 24.8721 21.6539 24.6443C21.8755 24.4166 22 24.1078 22 23.7857V11.0357C22 10.7137 21.8755 10.4048 21.6539 10.1771C21.4322 9.94936 21.1316 9.82143 20.8182 9.82143V9.82143ZM13.1364 9.21429H17.8636V11.6429H13.1364V9.21429ZM20.8182 23.7857H10.1818V11.0357H11.9545V12.8571H19.0455V11.0357H20.8182V23.7857Z",
    fill: "#348287"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportForInsights);
export default __webpack_public_path__ + "static/media/report-for-insights.89886429a2962edd21fd775325668112.svg";
export { ForwardRef as ReactComponent };